import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { SuspendedLoadingsDto } from '../schema/types';
import { UserCalendarUrl } from '../../UserDashboardUrl';

const getSuspendedLoadings = () =>
  apiClient
    .get<SuspendedLoadingsDto[]>(expand(UserCalendarUrl.SUSPENDED_LOADINGS))
    .then((response) => response.data);

export const useGetSuspendedLoadingsQuery = createApiQueryHook(
  ['suspended-loadings'],
  getSuspendedLoadings,
);
